<script>
import { mdiWeatherNight, mdiWeatherSunny, mdiThemeLightDark } from '@mdi/js'
import { setThemeMode, storedThemeMode } from '@src/plugins/theme'

// A compact light/dark switcher for the app bar, mirroring language-toggle.
//
// Three modes, not a two-way switch: SYSTEM follows the operating system and is
// the default, so a machine already set to dark opens BowVue dark without
// anyone visiting a menu. Deliberately usable while signed out, like the
// language toggle, since the login screen is the first thing a dark-mode user
// sees.
export default {
  name: 'ThemeToggle',
  data() {
    return {
      // Read once at mount rather than computed: localStorage is not reactive,
      // and setThemeMode is the only thing that changes it from here.
      mode: storedThemeMode(),
    }
  },
  computed: {
    modes() {
      return [
        {
          value: 'light',
          label: this.$t('theme.light'),
          icon: mdiWeatherSunny,
        },
        { value: 'dark', label: this.$t('theme.dark'), icon: mdiWeatherNight },
        {
          value: 'system',
          label: this.$t('theme.system'),
          icon: mdiThemeLightDark,
        },
      ]
    },
    activeIcon() {
      const found = this.modes.find((m) => m.value === this.mode)
      return found ? found.icon : mdiThemeLightDark
    },
  },
  methods: {
    choose(value) {
      this.mode = setThemeMode(value)
    },
  },
}
</script>

<template>
  <v-menu location="bottom end">
    <template v-slot:activator="{ props }">
      <v-btn
        v-bind="props"
        variant="text"
        color="white"
        size="small"
        icon
        :title="$t('theme.label')"
        :aria-label="$t('theme.label')"
      >
        <v-icon :icon="activeIcon" />
      </v-btn>
    </template>
    <v-list density="compact" min-width="180">
      <v-list-item
        v-for="option in modes"
        :key="option.value"
        :active="option.value === mode"
        :prepend-icon="option.icon"
        :title="option.label"
        @click="choose(option.value)"
      />
    </v-list>
  </v-menu>
</template>
